"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactionFilterDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const shared_1 = require("../shared");
const boolean_transform_1 = require("../../constants/boolean.transform");
class ReactionFilterDto extends shared_1.PaginationOptionsDto {
    constructor(reactionFilterOptions) {
        super();
        if (!reactionFilterOptions)
            return;
        this.name = reactionFilterOptions.name;
        this.description = reactionFilterOptions.description;
        this.daysUntilReaction = reactionFilterOptions.daysUntilReaction;
        this.passMessage = reactionFilterOptions.passMessage;
        this.dailyCapacity = reactionFilterOptions.dailyCapacity;
        this.complianceRequired = reactionFilterOptions.complianceRequired;
        this.searchInput = reactionFilterOptions.searchInput;
        this.schoolId = reactionFilterOptions.schoolId;
        this.active = reactionFilterOptions.active;
    }
    name;
    description;
    daysUntilReaction;
    passMessage;
    dailyCapacity;
    complianceRequired;
    searchInput;
    schoolId;
    active;
}
exports.ReactionFilterDto = ReactionFilterDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], ReactionFilterDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], ReactionFilterDto.prototype, "description", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], ReactionFilterDto.prototype, "daysUntilReaction", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], ReactionFilterDto.prototype, "passMessage", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], ReactionFilterDto.prototype, "dailyCapacity", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], ReactionFilterDto.prototype, "complianceRequired", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], ReactionFilterDto.prototype, "searchInput", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ReactionFilterDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], ReactionFilterDto.prototype, "active", void 0);
